import { environment } from '@environments/environment';
import { MODULE } from './module.config';

export const APP_CONFIG = {
  module: MODULE.name,
  apiBaseUrl: environment.apiBaseUrl,
  s3Url: environment.s3Url,
  cfVideoBase: environment.cfVideoBase,
};
